// ReactJs
import React from 'react'
// Node modules
import styled from 'styled-components'
// Styles
import Icon from '@shared/components/Icon'
import theme from '@shared/utils/theme'
import { get } from 'lodash'
import moment from "moment";
import {getBabysittingModeFrom} from "@shared/utils/baby-sitting-modes";

const WelcomePageNotificationContainer = styled.div`

  .notification-summary {
    display: flex;
    height: 35px;
    margin-bottom: 5px;
    justify-content: space-between;
    align-items: center;
    background-color: ${ theme.palette.light_grey };
    cursor: pointer;
    &:hover {
      background-color: ${ theme.palette.grey };
    }
  }

  .notification-date {
    width: 40px;
    padding-left: 20px;
    font-size: 12px;
    line-height: 14px;
    font-weight: normal;
    text-transform: lowercase;
  }
  
  .child-name {
    font-weight: bold;
    text-transform: lowercase;
  }
  .child-name::first-letter {
    text-transform: uppercase;
  }

  .babysitting-mode {
    width: 70px;
    font-size: 12px;
    line-height: 14px;
  }
  
  .title {
    font-weight: bold;
  }
  
  .notification-detail {
    padding-right: 5px;
    text-align: right;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    text-decoration: underline;
  }

`

export default function WelcomePageNotification({ notification,
                                            action, babysittingModes,
                                            ...props }) {

  return (

    <WelcomePageNotificationContainer>

      <div className="notification-summary" onClick={ action }>

        <div className="notification-date">
          { moment(get(notification, 'createdDate', 'Non défini')).format('DD/MM') }
        </div>

        { notification.childName && notification.babysittingMode ?
          <>
            <div className="child-name" >
              { notification.childName }
            </div>
            <div className="babysitting-mode" >
              { getBabysittingModeFrom(babysittingModes, notification.babysittingMode, 'name') }
            </div>
          </> :
          <div className="title">
            { notification.title }
          </div>
        }

        <div className="notification-detail">
          {  'Je lis' }
          { action && <Icon name="chevron_right" /> }
        </div>
      </div>
    </WelcomePageNotificationContainer>

  )

}
